module.exports = function () {
  /**
  * @file core/BDPolyfill/parser.js
  * 老端能力，各种恶心的端能力版本问题这里处理
  * @author gaojiexuan@baidu.com
  */
  var $ = require('../../utils/_bdboxWrapper');
  /* istanbul ignore next */


  var extend = require('../../thirdParty/bdbox/extend');

  var map = require('./filter');

  var platformAPI = require('../../utils/platform');

  return function (module, action, data, platform) {
    var configs = map[module + '/' + action];
    var result = {};
    var boxType = platformAPI.boxType;
    var os = platform; // lite\info版的key为系统版本与框版本拼接

    if (boxType !== 'main') {
      platform = [platform, boxType].join('');
    }

    var platformConfig = configs[platform];

    if (!!platformConfig) {
      var filter = platformConfig.filter || configs[os].filter || {};
      var thunk = platformConfig.thunk || configs[os].thunk;
      var result = {
        module: module,
        action: action,
        data: data,
        extData: {},
        hasCB: platformConfig.hasCB || configs[os].hasCB,
        callbackKey: filter.callbackKey || ''
      };

      if (!!filter && $.isFunction(filter)) {
        extend(result, filter(module, action, data));
      }

      if (!!thunk && $.isFunction(thunk)) {
        result.thunk = thunk;
      }

      return result;
    }
  };
}();